import { Badge, SimpleFlexbox } from 'ctm-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pageContext } from 'ctm-util-functions';
import { getFormValue } from '../../core/state_selectors';
import { useStyles } from './styles';

const validatePageIsComprehensiveInsuredYears = (name) => {
    switch (name) {
        case 'regular_driver_comprehensive_insured_years':
            break;
        default:
            throw new Error(`Unknown page name: ${name}`);
    }
};

const NEXT_PAGE_NAME = 'regular_driver_claims';
const COMPONENT_IDENTIFIER = 'coverDetail.driver.comprehensiveInsuredYears';

// * we are not passing `dispatch` to the Badge component
// * instead we are dispatching actions directly from ComprehensiveInsuredYears
//   * this separates concerns and makes code execution easier to reason about
// * so Badge isn't dispatching any actions.
//   * As a result, we don't use all parts of the schema.
const UNUSED = 'UNUSED';

const ComprehensiveInsuredYears = () => {
    const pageName = pageContext.getProps().pageState.pageName;
    validatePageIsComprehensiveInsuredYears(pageName);
    const yearsList = [
        {
            value: '0',
            innerLabel: 'None'
        },
        {
            value: '1',
            innerLabel: '1'
        },
        {
            value: '2',
            innerLabel: '2'
        },
        {
            value: '3',
            innerLabel: '3'
        },
        {
            value: '4',
            innerLabel: '4'
        },
        {
            value: '5',
            innerLabel: '5'
        }
    ];

    const classes = useStyles();

    const dispatch = useDispatch();
    const updateState = (years) => {
        dispatch({
            type: 'SET_VALUE',
            identifier: COMPONENT_IDENTIFIER,
            stateKey: 'vertical.quote',
            value: years
        });
        const history = pageContext.getProps().browserHistory;
        history.push(`/car-insurance/journey/${NEXT_PAGE_NAME}`);
    };

    const isComprehensiveInsured = useSelector((state) => getFormValue(state, 'coverDetail.driver.comprehensiveInsured'));

    let variant = 'size_xs_20_sm_15';
    if (isComprehensiveInsured === 'N' && yearsList[yearsList.length - 1].value === '5') {
        yearsList.pop(); // Business rule: Remove '5' if the driver has indicated they have not been comprehensively insured
        variant = 'size_xs_50_sm_20';
    }

    const selectedValue = useSelector((state) => getFormValue(state, COMPONENT_IDENTIFIER)) || '';

    return (
        <SimpleFlexbox className={classes.mainContainer}>
            {yearsList.map((year) => {
                return (
                    <Badge
                        id={year.value}
                        key={year.value}
                        optionProps={{
                            innerLabel: year.innerLabel,
                            value: year.value,
                            variant
                        }}
                        eventProps={{ onClick: () => updateState(year.value) }}
                        schema={{
                            identifier: COMPONENT_IDENTIFIER,
                            stateKey: UNUSED,
                            variant: 'center',
                            field: {
                                type: 'badgegroup',
                                metaType: 'radio',
                                UIComponent: 'badge_primary_semi_rounded',
                                values: yearsList
                            }
                        }}
                        value={selectedValue}
                    />
                );
            })}
        </SimpleFlexbox>
    );
};

export { ComprehensiveInsuredYears };
